export default __webpack_public_path__ + "static/media/Juan_Prieto.0d430576.png";